<ul class="list-unstyled">
	<li *ngIf="location">
		<a [href]="'https://www.google.com/maps/search/?api=1&query=' + encodeLocationURI()" target="_blank"><i class="ion-ios-pin-outline mr-2"></i> {{ location }}</a>
	</li>
	<li *ngIf="mail" class="ml-4">
		<a href="mailto:{{ mail }}"><i class="ion-ios-mail-outline mr-2"></i> {{ mail }}</a>
	</li>
</ul>
